import { Square } from 'lucide-react';
import { Link } from 'react-router';
import { Tooltip } from '@/design-system/components/tooltip';
import { useNow } from '@/design-system/time/use-now';
import { useRunningTimer, useTimerActions } from '@/lib/time';

const clock = (ms: number) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h ? `${h}:` : ''}${String(m).padStart(h ? 2 : 1, '0')}:${String(s % 60).padStart(2, '0')}`;
};

/** Timer rodando na barra superior: o relógio corre ao vivo; um clique para. */
export function TimerWidget() {
  const running = useRunningTimer();
  const { stop } = useTimerActions();
  const now = useNow(1000);
  const r = running.data;
  if (!r) return null;
  const label =
    (r.material ? `${r.material.name} · ` : '') +
    (r.task?.title ?? r.project?.name ?? (r.description || 'Sem tarefa'));
  return (
    <div className="flex items-center gap-1 rounded-full bg-signal-soft py-1 pr-1 pl-3 text-[12.5px]">
      <span className="size-1.5 animate-pulse rounded-full bg-signal" />
      <Link to="/time" className="hidden max-w-40 truncate text-fg-muted hover:text-fg md:block">
        {label}
      </Link>
      <span className="tabular font-mono font-medium text-fg">
        {clock(now.getTime() - new Date(r.startedAt).getTime())}
      </span>
      <Tooltip label="Parar timer">
        <button
          type="button"
          aria-label="Parar timer"
          onClick={() => stop.mutate()}
          className="flex size-6 items-center justify-center rounded-full text-fg-muted hover:bg-press hover:text-fg"
        >
          <Square className="size-3 fill-current" />
        </button>
      </Tooltip>
    </div>
  );
}
